import React, { useEffect, useState, useRef } from "react";
import { aboutMe, profileImage, name, role } from "../config/config";
import { TypeAnimation } from 'react-type-animation';

const About = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  const checkVisibility = () => {
    if (sectionRef.current) {
      const rect = sectionRef.current.getBoundingClientRect();
      if (rect.top <= window.innerHeight && rect.bottom >= 0) {
        setIsVisible(true);
      }
    }
  };

  useEffect(() => {
    checkVisibility(); // Check visibility on mount
    window.addEventListener("scroll", checkVisibility);
    return () => window.removeEventListener("scroll", checkVisibility);
  }, []);

  return (
    <section
      id="about"
      ref={sectionRef}
      className={`text-white p-4 flex items-center justify-center mt-0 bg-opacity-0 transition-transform duration-700 ${
        isVisible
          ? "translate-x-0 opacity-100 ease-out-cubic"
          : "-translate-x-full opacity-0"
      }`}
    >
      <style jsx>{`
        .ease-out-cubic {
          transition-timing-function: cubic-bezier(0.1, 1, 0.1, 1);
        }
      `}</style>
      <div className="flex flex-col md:flex-row items-center justify-between w-full max-w-4xl mx-auto space-y-8 md:space-y-0 md:space-x-8 transform transition-all">
        {/* About Text Section */}
        <div className="text-gray-200 md:w-[60%] md:mb-0">
          <h2 className="text-3xl sm:text-4xl font-extrabold mb-4 animate-pulse text-center md:text-left text-sky-400">
            About Me
          </h2>
          <div className="h-8 sm:h-12 mb-4 text-xl sm:text-2xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-pink-500 text-center md:text-left">
            <TypeAnimation
              sequence={[
                'Backend Engineer',
                2000,
                'Building Agentic AI 🤖',
                2000,
                'Designing Distributed Systems ⚡',
                2000
              ]}
              wrapper="span"
              speed={50}
              repeat={Infinity}
            />
          </div>
          <p className="text-sm sm:text-lg font-medium leading-relaxed transition duration-300 text-center md:text-left">
            {aboutMe}
          </p>
        </div>

        {/* Profile Image and Button Section */}
        <div className="flex flex-col items-center justify-center md:w-[40%]">
          {/* Profile Image Container */}
          <div className="relative w-fit mx-auto group mb-6">
            {/* Profile Image */}
            <img
              src={profileImage}
              alt="Profile"
              className="rounded-2xl w-48 h-48 sm:w-56 sm:h-56 object-cover shadow-[0_0_30px_rgba(56,189,248,0.3)] border border-sky-400/50 transform transition-transform duration-500 group-hover:scale-105"
            />

            {/* Name and Role Section */}
            <div className="absolute -bottom-4 left-1/2 transform -translate-x-1/2 w-full min-w-[200px] sm:min-w-[240px] text-center opacity-0 group-hover:opacity-100 translate-y-4 group-hover:translate-y-0 transition-all duration-500 bg-black/50 backdrop-blur-xl border border-white/10 text-white p-3 rounded-2xl shadow-[0_8px_32px_rgba(0,0,0,0.5)]">
              <h3 className="text-lg font-bold tracking-wide">{name}</h3>
              <p className="text-xs font-semibold text-sky-300 mt-1">{role}</p>
            </div>
          </div>
          
          {/* Portfolio Button */}
          <div className="mt-2 w-full flex justify-center">
            <a
              href="https://meetguddudev.vercel.app/"
              target="_blank"
              rel="noopener noreferrer"
              className="px-8 py-3 w-48 text-center font-bold text-white bg-white/5 hover:bg-white/10 border border-white/10 rounded-full backdrop-blur-md shadow-[0_4px_30px_rgba(0,0,0,0.1)] hover:shadow-[0_4px_30px_rgba(255,255,255,0.1)] hover:scale-105 transition-all duration-300"
            >
              Hire Me
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
